import { injectable, inject } from 'inversify';
import { TYPES } from '@framework/config/DI/types';
import { DomainConfig } from '@framework/config/DI/domainModule/DomainConfig';
import { IDealroadshowConfig } from '../IDealroadshowConfig';
import config from '../config';

@injectable()
class ConfigFactory {
  constructor(
    @inject(TYPES.DomainConfig) private domain: DomainConfig,
  ) {}

  create(): IDealroadshowConfig {
    return {
      ...config,
      hostname: `${ this.domain.dealroadshowDomain }`,
    };
  }
}

export default ConfigFactory;
